export const MAIN_PURPLE = "#E01313";
export const MAIN_WHITE = "#CACAD0";
export const SECONDARY_GRAY = "#888888";
export const DEFAULT_WHITE = "#FAFAFA";
